const locale = {
  placeholder: 'انتخاب زمان',
};

export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/fa_IR.tsx